export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(650)]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(650)]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  listitemRoot: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      flexDirection: "column",
    },
  },
  fieldStyle: {
    display: "flex",
    [theme.breakpoints.down(400)]: {
      flexDirection: "column",
    },
  },
});
